<div class="row page-titles">
    <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor"><i class="text-secondary fa-solid fa-truck-ramp-box"></i> Ubicar entrada directa a Stock </h3>
        <h3 *ngIf="entrada.almNombre"
            class="text-themecolor monospace ml-4">
            <small>{{entrada.almNombre}}</small> - {{entrada.cliNombre}}
        </h3>
    </div>
</div>

<div class="row animated fadeIn fast">


    <!-- Formulario -->
    <div class="col-12">
        <div class="card border border-info rounded">

            <div class="card-body p-2 ">

                <form class="form"
                      [formGroup]="entradaForm"
                      [ngClass]="{'form-horizontal': true}">

                    <!-- Artículos del palé en diferentes ubicaciones -->
                    <div class="row">


                        <!-- id_articulo -->
                        <div class="col-4">
                            <div class="form-group"
                                 [ngClass]="{ 'has-danger': enviado && f['id_articulo'].errors }">
                                <label class="form-control-label"> Artículo: </label>
                                <select formControlName="id_articulo"
                                        class="form-control"
                                        [ngClass]="{ 'form-control-danger': enviado && f['id_articulo'].errors }"
                                        (change)="idArticuloChange($event)">
                                    <option *ngIf="loading"
                                            value="">Cargando...</option>
                                    <option *ngIf="!loading"
                                            value="">Selecciona...</option>
                                    <option *ngFor="let articulo of articulosList"
                                            [value]=articulo.id>
                                        {{articulo.ean}} - {{articulo.descripcion}}
                                    </option>
                                </select>
                                <div *ngIf="enviado &&  f['id_articulo'].errors"
                                     class="form-control-feedback">
                                    <div *ngIf="f['id_articulo'].errors['required']">Obligatorio</div>
                                    <div *ngIf="entradaForm.get('id_articulo')?.errors?.['apiError']">{{
                                        entradaForm.get('id_articulo')?.errors?.['apiError'] }}</div>
                                </div>
                            </div>
                        </div>



                        <!-- cantidad -->
                        <div class="col-3">
                            <div class="form-group"
                                 [ngClass]="{ 'has-danger': enviado && f['cantidad'].errors }">
                                <label class="form-control-label"> Cantidad: </label>
                                <input type="text"
                                       formControlName="cantidad"
                                       class="form-control"
                                       maxlength="13">

                                <div *ngIf="enviado &&  f['cantidad'].errors"
                                     class="form-control-feedback">
                                    <div *ngIf="f['cantidad'].errors['required']">Obligatorio</div>
                                    <div *ngIf="f['cantidad'].errors['min']">Mínimo 1</div>
                                    <div *ngIf="f['cantidad'].errors['max']">Máximo 99.999</div>
                                    <div *ngIf="entradaForm.get('cantidad')?.errors?.['apiError']">{{
                                        entradaForm.get('cantidad')?.errors?.['apiError'] }}</div>
                                </div>

                            </div>
                        </div>


                        <!-- ubicacion -->
                        <div class="col-5">
                            <div class="form-group"
                                 [ngClass]="{ 'has-danger': enviado && f['ubicacion'].errors }">
                                <label class="form-control-label"> Ubicación: </label>
                                <input #txtUbicacion
                                       type="text"
                                       formControlName="ubicacion"
                                       class="form-control"
                                       maxlength="17"
                                       mask="00.00.00.00.00.00">

                                <div *ngIf="enviado &&  f['ubicacion'].errors"
                                     class="form-control-feedback">
                                    <div *ngIf="f['ubicacion'].errors['required']">Obligatorio</div>
                                    <div *ngIf="f['ubicacion'].errors['minlength']">12 caracteres</div>
                                    <div *ngIf="f['ubicacion'].errors['maxlength']">12 caracteres</div>
                                    <div *ngIf="entradaForm.get('ubicacion')?.errors?.['apiError']">{{
                                        entradaForm.get('ubicacion')?.errors?.['apiError'] }}</div>
                                </div>

                            </div>
                        </div>



                    </div><!-- row -->

                    <!-- sku y descripción -->
                    <div *ngIf="articuloSelected.ean"
                         class="row">
                        <div class="col-12">
                            <h6 class="card-title text-info">{{articuloSelected.ean}} - {{articuloSelected.descripcion}}</h6>
                        </div>
                    </div>


                    <!-- Botones -->
                    <div class="row">
                        <div class="col-6">
                            <button type="button"
                                    [disabled]="loading"
                                    class="btn btn-outline-info px-2 px-sm-3"
                                    (click)="cerrarEntradaDirecta()">
                                Cerrar entrada
                            </button>
                        </div>
                        <div class="col-6 text-right">
                            <button type="button"
                                    [disabled]="loading"
                                    class="btn btn-success px-2 px-sm-3"
                                    (click)="enviar()">
                                Ubicar
                            </button>
                        </div>
                    </div>


                </form>

            </div>


        </div> <!-- card -->
    </div> <!-- col-lg-12 -->



    <!-- Lista de artículos ya ubicados -->
    <div class="col-12 animated fadeIn fast">

        <div class="card border border-info rounded">

            <div class="card-body">
                <button [disabled]="loading"
                        (click)="getEntrada()"
                        class="btn btn-outline-info float-right">
                    &nbsp;<i class="fa-solid fa-rotate"
                       [class.fa-spin]="loading"></i>&nbsp;
                </button>
                <h4 class="card-title text-info"><small>Albarán:</small> {{entrada.albaran}}</h4>
                <h6 class="card-subtitle">Referencias ubicadas</h6>
                <div class="bootstrap-table">
                    <div class="table-responsive">

                        <div class="table-responsive">
                            <table class="table table-sm table-bordered fs-10">

                                <thead>
                                    <tr>
                                        <th>EAN</th>
                                        <th>SKU</th>
                                        <th style="text-align: center;">Cant.</th>
                                        <th>Ubicación</th>
                                    </tr>
                                </thead>

                                <!-- Si hay detall y no está ubicado, mostrarlo -->
                                <tbody *ngIf="entrada.detall">
                                    <ng-container *ngFor="let lin of entrada.detall; let i = index">

                                        <tr>

                                            <td> {{ lin.artEan }} </td>
                                            <td>
                                                <small>{{ lin.artSku }}</small>
                                                <span *ngIf="lin.swDefectuoso == Const.DEFECTUOSO">
                                                    <i title="Defectuoso"
                                                       class="text-warning ml-1 fa-solid fa-triangle-exclamation"></i>
                                                </span>
                                            </td>
                                            <td style="text-align: right;">
                                                <div class="monospace">
                                                    {{lin.cantidad | number: '0.0-0':'es'}}
                                                </div>
                                            </td>
                                            <td class="monospace"> <small>{{ lin.ubicacion! | mask: '00.00.00.00.00.00' }} </small></td>

                                        </tr>

                                    </ng-container>
                                </tbody>

                            </table>
                        </div>


                    </div>
                </div>
            </div>

        </div>

    </div>


</div>